import {Typography} from "antd";
import {useEffect, useState} from "react";
import ResultListBox from "../ResultListBox";
import WinFormInput from "../WinFormInput";
import ResultHeaderCell from "../../../../components/table/ResultHeaderCell";
import UIComponentHelper from "../UIComponentHelper";
import ResultBodyCell from "../../../../components/table/ResultBodyCell";

export default function PierEditor({windowName, data, title, targetWindow, selectedPier, onChangePier}) {
    const getPierData = () => {
        if(data?.length === 0)
            return {}

        return data.find(x => x.pier_name === selectedPier)
    }

    useEffect(() => {
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'center-sta-up'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'center-sta-ds'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'apply-floating-debris'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'debris-width'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'debris-height'})
        UIComponentHelper.setStyleForTable({targetWindow, windowName, name: 'pier-table', skipIndex: [0]})
    }, [selectedPier, data]);

    return (
        <div style={{}}>
            <Typography.Text
                style={{fontSize: '11pt', fontWeight: 'bold', backgroundColor: 'white', width: '100%', marginLeft: 4}}>
                Pier Editor - {selectedPier} - {title}
            </Typography.Text>
            <div style={{
                width: 340,
                backgroundColor: '#f5f5f5',
                fontSize: '9pt',
                padding: 2,
                paddingLeft: 4,
                paddingRight: 4,
                border: '1px solid #cfcfcf'
            }} id={windowName}>
                <div style={{display: 'flex', marginBottom: 8, marginLeft: 68}}>
                    <div style={{width: 64}}>Pier:</div>
                    <div>
                        <ResultListBox
                            width={150}
                            text={' '}
                            value={selectedPier}
                            list={data?.map(x => x.pier_name)}
                            onChange={(val) => onChangePier && onChangePier(val)}
                        />
                    </div>
                </div>
                <table style={{width: '100%'}}>
                    <tr>
                        <td style={{width: 60}}></td>
                        <td>
                            Centerline Station Upstream
                        </td>
                        <td style={{width: 82, paddingRight: 2}}>
                            <WinFormInput id={`${windowName}-center-sta-up`} style={{width: '100%'}}>
                                {getPierData()?.CenterlineUS}
                            </WinFormInput>
                        </td>
                    </tr>
                    <tr>
                        <td style={{width: 60}}></td>
                        <td>
                            Centerline Station Downstream
                        </td>
                        <td style={{width: 82, paddingRight: 2}}>
                            <WinFormInput id={`${windowName}-center-sta-ds`} style={{width: '100%'}}>
                                {getPierData()?.CenterlineDS}
                            </WinFormInput>
                        </td>
                    </tr>
                </table>
                <fieldset style={{border: '1px solid #a5a5a5', padding: 2, marginTop: 6, paddingBottom: 12}}>
                    <legend style={{fontSize: '9pt', marginLeft: 4, paddingLeft: 2, width: 110}}>Floating Pier Debris
                    </legend>
                    <table>
                        <tr>
                            <td style={{width: 100}}></td>
                            <td colSpan={2}>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <input name={`${windowName}-apply-floating-debris`} type={'checkbox'}
                                           readOnly={true}
                                           value={'apply-floating-debris'} checked={false}/>
                                    <label style={{marginLeft: 2}}>Apply floating debris to this pier</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: 100}}></td>
                            <td style={{width: 144}}>Debris Width</td>
                            <td style={{width: 80}}>
                                <WinFormInput id={`${windowName}-debris-width`} style={{width: '100%'}}>
                                    {getPierData()?.DebrisWidth}
                                </WinFormInput>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: 100}}></td>
                            <td>Debris Height</td>
                            <td style={{width: 80}}>
                                <WinFormInput id={`${windowName}-debris-height`} style={{width: '100%'}}>
                                    {getPierData()?.DebrisHeight}
                                </WinFormInput>
                            </td>
                        </tr>
                    </table>
                </fieldset>
                <table style={{width: '100%', marginTop: 8}}>
                    <thead style={{tableLayout: 'fixed', width: '100%', display: 'block'}}>
                    <tr style={{backgroundColor: '#008080', color: 'white', textAlign: 'center'}}>
                        <td colSpan={3}>Upstream</td>
                        <td colSpan={2}>Downstream</td>
                    </tr>
                    <tr>
                        <ResultHeaderCell style={{width: 30}}></ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>Pier Width</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>Elevation</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>Pier Width</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>Elevation</ResultHeaderCell>
                    </tr>
                    </thead>
                    <div style={{overflow: 'auto'}}>
                        <tbody id={`${windowName}-pier-table`}
                               style={{height: 150, tableLayout: 'fixed', width: '100%', display: 'block'}}>
                        {
                            UIComponentHelper.getTableData({
                                table1: (getPierData()?.USTable || []),
                                table2: (getPierData()?.DSTable || []),
                                min_len: 10
                            }).map((x, idx) => (
                                <tr>
                                    <ResultHeaderCell style={{width: 30}}>{idx + 1}</ResultHeaderCell>
                                    <ResultBodyCell
                                        style={{backgroundColor: 'white', width: 70,}}>{x[0]}</ResultBodyCell>
                                    <ResultBodyCell
                                        style={{backgroundColor: 'white', width: 70,}}>{x[1]}</ResultBodyCell>
                                    <ResultBodyCell
                                        style={{backgroundColor: 'white', width: 70,}}>{x[2]}</ResultBodyCell>
                                    <ResultBodyCell
                                        style={{backgroundColor: 'white', width: 70,}}>{x[3]}</ResultBodyCell>
                                </tr>
                            ))
                        }
                        </tbody>
                    </div>
                </table>
            </div>

        </div>
    )
}